import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';

import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { AtividadeAta } from '@/features/comissoes/dashboard-comissoes/comissoes-dashboard.model';

/**
 * Card lateral de atividades da ata: lista as atividades, permite selecionar uma linha e dispara
 * as ações (novo/editar/excluir) e a marcação "resolvida". Apenas apresentação — a persistência
 * e o diálogo de cadastro ficam no componente pai (`AtaReuniaoComponent`).
 */
@Component({
    selector: 'app-ata-atividades',
    standalone: true,
    imports: [ButtonModule, TableModule, CanDirective],
    templateUrl: './ata-atividades.html',
    styleUrls: ['./ata-atividades.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AtaAtividadesComponent {
    /** Atividades vinculadas à reunião. */
    readonly atividades = input<AtividadeAta[]>([]);
    /** Atividade selecionada (destaca a linha). */
    readonly atividadeSelecionada = input<AtividadeAta | null>(null);
    /** Estado do checkbox "resolvida" da atividade selecionada. */
    readonly atividadeResolvida = input(false);
    /** Habilita as ações (status da ata permite alteração). */
    readonly permiteAlteracao = input(false);
    /** Renderiza sem o card externo (flat), para uso dentro de um `app-card-content`. */
    readonly plano = input(false);

    /** Abrir o diálogo de edição da atividade informada. */
    readonly editar = output<AtividadeAta>();
    /** Excluir a atividade informada. */
    readonly excluir = output<AtividadeAta>();
    /** Selecionar uma atividade da lista. */
    readonly selecionar = output<AtividadeAta>();
    /** Alternar a flag "resolvida" da atividade selecionada. */
    readonly alternarResolvida = output<boolean>();

    protected readonly roleAtividadesEditar = PERMISSOES.comissoes.atividades.editar;
    protected readonly roleAtividadesExcluir = PERMISSOES.comissoes.atividades.excluir;

    protected aoAlternarResolvida(evento: Event): void {
        this.alternarResolvida.emit((evento.target as HTMLInputElement).checked);
    }
}
